module.exports = __webpack_public_path__ + "media/img/Landing_Page/S2U-Lau-Jie-Fe-b7c2e8f56e84febfd5de73f3d4306ba4.jpg";